import { useTheme as useThemeHook } from "@emotion/react";
import { CatchTheme } from "../../theme";

export function useTheme<T = CatchTheme>(): T {
  return useThemeHook() as T;
}
